import React, { type ReactNode, useMemo } from "react";
import Segment, { type SegmentProps } from "./Segment/Segment";
import MoreMenu from "./MoreMenu/MoreMenu";
import { useSegmentCalculations } from "./useSegmentCalculations";
import "./segments.scss";

type Props = {
  children: ReactNode;
  to: string;
};

function Segments(props: Props) {
  const { children, to } = props;

  const { containerRef, visibleSegments, overflowSegments } = useSegmentCalculations(children);

  const visibleSegmentsDisplay = useMemo(() => {
    return visibleSegments.map((child) => {
      if (!React.isValidElement<SegmentProps>(child)) {
        return null;
      }
      const key = child.props.to || "/";
      return React.cloneElement(child, {
        key,
        to: child.props.to ? `${to}/${child.props.to}` : to,
      });
    });
  }, [visibleSegments, to]);

  return (
    <div className="segment-control" role="navigation" ref={containerRef}>
      {visibleSegmentsDisplay}
      {overflowSegments.length > 0 && <MoreMenu segments={overflowSegments} basePath={to} />}
    </div>
  );
}

Segments.Segment = Segment;

export default Segments;
